import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SettingsRequestReviewModalComponent } from '../request-review-modal/request-review-modal.component';


@Component({
  selector: 'btn-review-request',
  template: `
      <span *renderingPermissionDirective="['BulkSettingReviewer']">
        <button (click)="btnClickedHandler()" class="lx-btn-small lx-btn-negative"
        *ngIf="status==='Awaiting Approval'">Review</button>
      </span>
    `,
})

export class BtnReviewRequestComponent implements ICellRendererAngularComp {
  private params: any;
  public status: string;
  public userName: string;
  public requester: string;

  constructor(
    private modalService: NgbModal
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.status = this.params.data.status;
    this.userName = this.params.userName;
    this.requester = this.params.data.requester;
  }

  btnClickedHandler() {
    const modal = this.modalService.open(SettingsRequestReviewModalComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
    modal.componentInstance.requestId = this.params.data.id;
    modal.componentInstance.reviewerName = this.userName;
    modal.result.then(
      (result) => {
        this.status = result;
      }
    );
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.params = params;
    this.status = this.params.data.status;
    this.userName = this.params.userName;
    this.requester = this.params.data.requester;
    return true;
  }
}
